import script from "./QuestionList.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionList.vue?vue&type=script&setup=true&lang=js"

import "./QuestionList.vue?vue&type=style&index=0&id=a0b31a70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0b31a70"]])

export default __exports__